import find from "../public/gifs/growseoson.gif";

export const seosonSteps = (ref1, ref2, ref3, ref4) => [
  {
    title: "رسم محدوده فصل رشدی",
    description:
      "برای مشخص کردن محدوده فصل رشدی با استفاده از دکمه مشخص شده در تصویر می‌بایست  برشی از زمین خود را جداکنید و سپس آن را انتخاب نمایید.",
    nextButtonProps: {
      children: "بعدی",
    },
  
    cover: (
      <img
      
        alt="tour.png"
        src={find}
      />
    ),
    target: () => ref1.current,
  },
  {
    title: "انتخاب کل محدوده",
    description:
      "همچنین اگر می‌خواهید تمام زمین را به عنوان محدوده فصل رشدی انتخاب نمایید، از این گزینه استفاده کنید.",
      prevButtonProps: {
        children: "قبلی",
      },
      nextButtonProps: {
      children: "متوجه شدم",
    },
  
  
    target: () => ref2.current,
  },

];
